import type { ModelConstructorParameter } from '../types/modelType';
import { OutpatientClinicEpisodeCategory } from './outpatientClinicEpisodeCategoryModel';

export class OutpatientClinicTaskTypeGroup {
    public id: string;
    public name: string;
    public episodeCategory: ModelConstructorParameter<typeof OutpatientClinicEpisodeCategory>;
    public sortOrder: number;

    constructor(options: OutpatientClinicTaskTypeGroup) {
        this.id = options.id;
        this.name = options.name;
        this.episodeCategory = new OutpatientClinicEpisodeCategory(options.episodeCategory);
        this.sortOrder = options.sortOrder;
    }
}
